/**
 * API CONFIGURATION
 * Central API endpoint configuration
 */

import { API_BASE_URL, API_VERSION, WS_BASE_URL } from '@/utils/constants';

const API_PREFIX = `/api/${API_VERSION}`;

export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: `${API_PREFIX}/auth/login`,
    LOGOUT: `${API_PREFIX}/auth/logout`,
    REFRESH: `${API_PREFIX}/auth/refresh`,
    ME: `${API_PREFIX}/auth/me`,
    CHANGE_PASSWORD: `${API_PREFIX}/auth/change-password`,
  },

  // Semantic State
  SEMANTIC: {
    STATE: `${API_PREFIX}/semantic/state`,
    EVENTS: `${API_PREFIX}/semantic/events`,
    HISTORY: `${API_PREFIX}/semantic/history`,
  },

  // Explanation
  EXPLANATION: {
    GENERATE: `${API_PREFIX}/explanation/generate`,
    RENDER: `${API_PREFIX}/explanation/render`,
    HISTORY: `${API_PREFIX}/explanation/history`,
    FEEDBACK: `${API_PREFIX}/explanation/feedback`,
  },

  // Correction
  CORRECTION: {
    APPLY: `${API_PREFIX}/correction/apply`,
    HISTORY: `${API_PREFIX}/correction/history`,
    STATS: `${API_PREFIX}/correction/stats`,
    FEEDBACK: `${API_PREFIX}/correction/feedback`,
  },

  // Knowledge Graph
  KNOWLEDGE_GRAPH: {
    GET: `${API_PREFIX}/knowledge-graph`,
    REASONING_PATH: `${API_PREFIX}/knowledge-graph/reasoning-path`,
    CONCEPT: `${API_PREFIX}/knowledge-graph/concept`,
    RELATIONSHIP: `${API_PREFIX}/knowledge-graph/relationship`,
  },

  // Multi-Timeframe — removed: multiTimeframeApi.ts now talks to shape-engine
  // directly (/consensus, /alignment, /hierarchy/{tf}, /suppress), matching
  // how the rest of shape-engine's endpoints (shapeSync.ts, detection) are
  // called. These three paths never existed on the backend.

  // Perception (Structure Detection)
  PERCEPTION: {
    STRUCTURES: `${API_PREFIX}/perception/structures`,
    DETECT: `${API_PREFIX}/perception/detect`,
  },

  // Dream Engine
  DREAM: {
    SCENARIOS: `${API_PREFIX}/dream/scenarios`,
    SIMULATE: `${API_PREFIX}/dream/simulate`,
    ANALYSIS: `${API_PREFIX}/dream/analysis`,
  },

  // Performance
  PERFORMANCE: {
    METRICS: `${API_PREFIX}/performance/metrics`,
    BREAKDOWN: `${API_PREFIX}/performance/breakdown`,
    TIMELINE: `${API_PREFIX}/performance/timeline`,
  },

  // Monitoring
  MONITORING: {
    SERVICES: `${API_PREFIX}/monitoring/services`,
    HEALTH: `${API_PREFIX}/monitoring/health`,
    STATUS: `${API_PREFIX}/monitoring/status`,
  },

  // Logs
  LOGS: {
    GET: `${API_PREFIX}/logs`,
    STREAM: `${API_PREFIX}/logs/stream`,
    SEARCH: `${API_PREFIX}/logs/search`,
  },

  // Metrics
  METRICS: {
    GET: `${API_PREFIX}/metrics`,
    TIMESERIES: `${API_PREFIX}/metrics/timeseries`,
    AGGREGATED: `${API_PREFIX}/metrics/aggregated`,
  },

  // Alerts
  ALERTS: {
    GET: `${API_PREFIX}/alerts`,
    CREATE: `${API_PREFIX}/alerts`,
    UPDATE: `${API_PREFIX}/alerts/:id`,
    DELETE: `${API_PREFIX}/alerts/:id`,
    RULES: `${API_PREFIX}/alerts/rules`,
    ACKNOWLEDGE: `${API_PREFIX}/alerts/:id/acknowledge`,
    RESOLVE: `${API_PREFIX}/alerts/:id/resolve`,
  },

  // Users
  USERS: {
    GET: `${API_PREFIX}/users`,
    CREATE: `${API_PREFIX}/users`,
    UPDATE: `${API_PREFIX}/users/:id`,
    DELETE: `${API_PREFIX}/users/:id`,
    PERMISSIONS: `${API_PREFIX}/users/:id/permissions`,
  },

  // Configuration
  CONFIG: {
    GET: `${API_PREFIX}/config`,
    UPDATE: `${API_PREFIX}/config`,
    RESET: `${API_PREFIX}/config/reset`,
  },

  // Voice
  VOICE: {
    PROCESS: `${API_PREFIX}/voice/process`,
    FEEDBACK: `${API_PREFIX}/voice/feedback`,
  },
};

export const WS_ENDPOINTS = {
  SEMANTIC_STREAM: '/ws/semantic-stream',
  LOGS_STREAM: '/ws/logs-stream',
  METRICS_STREAM: '/ws/metrics-stream',
  ALERTS_STREAM: '/ws/alerts-stream',
};

export { API_BASE_URL, WS_BASE_URL };
